document.getElementById('menu')!.addEventListener('click', (ev: any) => {
  ev.target.classList.toggle('is-showing');
});



// WEBPACK FOOTER //
// ./src/page.ts